import { RESPONSE_STATUS, CLEAR_RESPONSE, GET_ALL_NOTES } from './notesTypes'
export default (state, action) => {
    switch (action.type) {
        case GET_ALL_NOTES:
            return {
                ...state,
                all_notes: action.payload,
            }
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
